import React from 'react';
import Header from './Header';
import Navbar from './Navbar';
import Footer from './Footer';
import './Layout.css'; // Optional: for styling

const Layout = ({ children }) => {
    return (
        <div className="container-layout">
            <div className="app-layout">
                <Header/>
                <Navbar/>
                <main className="app-content">
                    {children}
                </main>
                <Footer/>
            </div>
        </div>

    );
};

export default Layout;